import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { scrollToTop } from 'common';
import { getSourcingSharedCampaignTypeOptions } from 'modules/sourcing-shared/forms';
import { CampaignType } from 'generated-graphql/types';

type HandleSourcingSharedCustomizeMessageBackControllerProps = {
  set: SharedSourcingStoreApi['setState'];
  get: SharedSourcingStoreApi['getState'];
  integrationCredentials: { provider?: string | null } | null;
  portalUrl: string | undefined | null;
};

export const handleSourcingSharedCustomizeMessageBackController = ({
  set,
  get,
  integrationCredentials,
  portalUrl
}: HandleSourcingSharedCustomizeMessageBackControllerProps) => {
  scrollToTop();

  const { candidateBatch, channelFormData } = get();

  // Guard: channelFormData should always exist when navigating back from Customize Message step,
  // as the user must have selected a channel to reach that step. If missing, fall back to
  // showing the Setup Application step to ensure a valid navigation path.
  if (!channelFormData?.channel) {
    set({ step: 'SETUP_APPLICATION' });
    return;
  }

  // Check if we should skip the Setup Application step
  const campaignTypeOptions = getSourcingSharedCampaignTypeOptions({
    hasAtsJobId: !!candidateBatch?.atsJobId,
    hasIntegrationCredentials: !!integrationCredentials,
    atsProvider: integrationCredentials?.provider,
    portalUrl,
    customJobPostingUrl: candidateBatch?.customJobPostingUrl,
    atsJobApplicationUrl: candidateBatch?.atsJobPostingUrl,
    channelType: channelFormData.channel
  });

  const shouldSkipSetupApplication =
    campaignTypeOptions.length === 1 &&
    campaignTypeOptions[0].value === CampaignType.RequestCvOutreach;

  if (shouldSkipSetupApplication) {
    // Skip Setup Application and go directly to Job Information
    set({ step: 'JOB_INFORMATION' });
  } else {
    set({ step: 'SETUP_APPLICATION' });
  }
};
